jQuery(document).ready(function($) {

	var scrollSpeed = 500;

	$('.background-slider').slick({
		dots: false,
		arrows: false,
		autoplay: true,
		infinite: true,
		speed: 1500,
		fade: true,
		cssEase: 'linear'
	});
	$('.background-slider .slide').attr('tabindex', '-1');

	$(document)
	.on('click', '.toggle-archive', function(e) {
		e.preventDefault();
		$('#reportArchive').foundation('open');
		$('#reportArchive').find('a, button').attr('tabindex', '0');
	})
	.on('close.zf.reveal', '#reportArchive', function() {
		var modal = $(this);
		modal.find('a, button').attr('tabindex', '-1');
	})
	.on('click', '.header-slider .next-arrow', function(e) {
		e.preventDefault();
		var currIndex = $(this).closest('.flexible-content').index();
		var nextIndex = (currIndex==0) ? 2 : currIndex + 1;
		var nextSection = $('.flexible-content:nth-child(' + nextIndex + ')');
		if (nextSection.length===0) return;
		$('html, body').animate({
			scrollTop: nextSection.offset().top - $('header.header').height()
		}, scrollSpeed);
	})
	.on('click', '.scroll-to-downloads', function(e) {
		e.preventDefault();
		if (e.type!=='click') {
			$("#downloads a[tabindex='0']").first().focus();
		}
		$('html, body').animate({
			scrollTop: $("#downloads").offset().top
		}, scrollSpeed);
	})
	.on('click', '.show-chapters', function(e) {
		e.preventDefault();
		$('body').addClass('chapter-overlay-open');
		//$('#downloads').addClass('open-chapters');
		var selectedReport = $(this).closest('article');
		var chapterOverlay = selectedReport.find('.chapter-overlay');
		chapterOverlay.removeClass('hidden');
		chapterOverlay.find('a').attr('tabindex', '0');
		if ($(window).width()<=1099) return; // Do not scroll for small/medium screens, because the overlay is fixed positioned on those.
		$('html, body').animate({
			scrollTop: $('#downloads').offset().top - $('header.header').innerHeight()
		}, scrollSpeed);
	})
	.on('click', '.hide-overlay', function(e) {
		e.preventDefault();
		$('body').removeClass('chapter-overlay-open');
		//$('#downloads').removeClass('open-chapters');
		var chapterOverlay = $(this).closest('.chapter-overlay');
		chapterOverlay.addClass('hidden');
		chapterOverlay.find('a').attr('tabindex', '-1');
	});

});